var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex-fill"},[_c('navbar'),_c('router-view',{staticClass:"main-content",class:{'print-landscape' : _vm.landscape}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }